import { PrettyNumbers } from '@/components/PrettyNumbers/PrettyNumbers.tsx';

export const PrettyNumbersPage = () => {
    return <PrettyNumbers />;
};
